import { render } from "./professionsDetailsPage.vue?vue&type=template&id=5ad87d54&scoped=true"
import script from "./professionsDetailsPage.vue?vue&type=script&lang=js"
export * from "./professionsDetailsPage.vue?vue&type=script&lang=js"

import "./professionsDetailsPage.vue?vue&type=style&index=0&id=5ad87d54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad87d54"]])

export default __exports__